export const checkIdType = (item) => {
    switch (item.id_type) {
        case '2':
            return "lokalizacje";
            break;
        case '14' :
            return "kolekcje"
            break;
            default:
                return "lokalizacje"
    }
}